export const authPaths = {
  SIGN_IN: "user/login",
};
